export default __webpack_public_path__ + "ultimate-champion-desktop-cn-54e373dda6d5c923056fc4b49df0ad24.png";